var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    _setup.BCard,
    {
      attrs: {
        "no-body": "",
        "border-variant": _setup.props.selected ? "brand" : "",
      },
    },
    [
      _c(_setup.BCardHeader, { staticClass: "aspect-1-1 bg-white" }, [
        _c("img", {
          staticClass: "p-1 frame-image",
          attrs: { src: _setup.imgSrc, alt: _setup.altText },
        }),
      ]),
      _c(_setup.BCardBody, { staticClass: "p-2" }, [
        _c("p", { staticClass: "card-text text-center" }, [
          _vm._v(_vm._s(_setup.description)),
        ]),
      ]),
      _c("div", { staticClass: "card-tags right" }, [
        _c("p", { staticClass: "tag green" }, [
          _vm._v("From £" + _vm._s(_setup.props.fromPrice) + " each"),
        ]),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }